@if (toastService.show) {
  <div class="toast-container position-fixed">
    <div class="toast-message"
      [ngClass]="toastService.type === 'success' ? 'toast-success' : 'toast-error'"
      role="alert"
      aria-live="assertive"
      aria-atomic="true">
      <p class="toast-text">{{ toastService.message }}</p>
    </div>
  </div>
}